import { render } from "./DesksView.vue?vue&type=template&id=af46f1c0&scoped=true"
import script from "./DesksView.vue?vue&type=script&lang=js"
export * from "./DesksView.vue?vue&type=script&lang=js"

import "./DesksView.vue?vue&type=style&index=0&id=af46f1c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af46f1c0"]])

export default __exports__